import { routes } from 'constants/routes';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useLanguage from 'hooks/useLanguage';
import useSearchParams from 'hooks/useSearchParams';
import React from 'react';

export default function HowItWorkMobileView() {
	const { section, searchLangParams } = useSearchParams();
	const { language } = useLanguage();
	const { t } = useTranslation();

	return (
		<div className='flex'>
			<div className='flex-1 w-full ml-20'>
				<StaticImage src='../../../../assets/secure-financing/flow/path-how-it-work-mobile2.png' alt="" placeholder='tracedSVG' />
			</div>
			<div className='flex-2 flex flex-col items-center justify-between pr-20'>
				<div>
					<p className='leading-12 font-bold'>{t('pageFinancingForCompany.howItWork.step.1.bold')}</p>
					<p className='leading-12'>{t('pageFinancingForCompany.howItWork.step.1.desc')}</p>
				</div>

				<div>
					<p className='leading-12 mb-05'>{t('pageFinancingForCompany.howItWork.step.2.title')}</p>
					<p className='leading-12'>
						<span>{t('pageFinancingForCompany.howItWork.step.2.desc')}</span>
						<Link to={`${routes[language].FOR_SUPPLIER}?${section}=${searchLangParams.section.declareCandidateAnimator}`} className='link' tw='!text-green-1'>
							{t('pageFinancingForCompany.howItWork.step.2.link')}
						</Link>
					</p>
				</div>

				<div>
					<p className='leading-12 mb-05'>{t('pageFinancingForCompany.howItWork.step.3.title')}</p>
					<p className='leading-12'>{t('pageFinancingForCompany.howItWork.step.3.desc.1')}</p>
					<Link to='https://apps.apple.com/pl/app/finteq/id1568493252' className='link' tw='!text-green-1'>
						{t('pageFinancingForCompany.howItWork.step.3.link.1')}
					</Link>
					<span>{t('pageFinancingForCompany.howItWork.step.3.desc.2')}</span>
					<Link to='https://play.google.com/store/apps/details?id=pl.finteq' className='link' tw='!text-green-1'>
						{t('pageFinancingForCompany.howItWork.step.3.link.2')}
					</Link>
				</div>

				<div>
					<p className='leading-12 font-bold mb-05'>{t('pageFinancingForCompany.howItWork.step.4.bold')}</p>
					<p className='leading-12'>
						<span>{t('pageFinancingForCompany.howItWork.step.4.desc')}</span>
					</p>
				</div>

				<div>
					<p className='leading-12 mb-05'>{t('pageFinancingForCompany.howItWork.step.5.title')}</p>
					<p className='leading-12'>{t('pageFinancingForCompany.howItWork.step.5.desc')}</p>
				</div>

				<div>
					<p className='leading-12 font-bold mb-05'>{t('pageFinancingForCompany.howItWork.step.6.bold')}</p>
					<p className='leading-12'>{t('pageFinancingForCompany.howItWork.step.6.desc')}</p>
				</div>
			</div>
		</div>
	);
}
